import SoftClosingBlockContainer from './soft-closing-block.container';

export default SoftClosingBlockContainer;
